import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { CreditIncreaseService } from '../credit-increase.service';
@Component({
  selector: 'app-collapse',
  standalone: true,
  imports: [],
  templateUrl: './collapse.component.html',
  styleUrl: './collapse.component.scss',
})
export class CollapseComponent implements OnInit {
  constructor(
    private contentfulService: ContentfulService,
    private creditIncreaseService: CreditIncreaseService
  ) {}
  page_content: any;
  contentfulData: any;
  currentYear: any;
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.creditIncreaseService.enLanguage.subscribe((res: any) => {
      this.getContentfulData(res ? 'en' : 'fr');
    });
  }
  getContentfulData(currentLang: any) {
    this.contentfulService
      .getEntry(currentLang, 'legalDisclaimer', {
        'fields.name': 'LegalDisclaimerCLI',
        include: 10,
      })
      .then((res: any) => {
        this.page_content = res;
        
        
      });
  }

  tranformData(components: any[]) {
    const transformedData: any = {};
    components.forEach((item: any) => {
      const key = item.fields.name;
      delete item.fields.name;
      transformedData[key] = item.fields;
    });
    return transformedData;
  }
}
